import Analytics from '../views/analytics/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/analytics',
		name: 'analytics',
		component: Analytics,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
